import CreateProduct from "./Create";
import ProductList from "./List";

export { CreateProduct, ProductList }